import { useFeatureFlag } from '@platform/core/feature-flags';

import { LegacyCapabilitiesGuard } from '@packages/components/capabilities/legacy-capabilities-guard';

// TODO S2CX-6935: Remove this component and inline guard when cleaning up feature flags
export const AssetsFeatureGuard = () => {
  const [gaRelease] = useFeatureFlag('ADS_GA_RELEASE');

  return (
    <LegacyCapabilitiesGuard
      capabilities={
        gaRelease
          ? {
              canAccessManageRisk: true,
            }
          : { assets: true }
      }
    />
  );
};
